import React, { ReactNode } from 'react';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import type { ScreenSize } from '@jbhi-fi/lanyard-ui/themes/breakpoints';

export type MatchRule = 'up' | 'down';

type UnmountAtBreakpointProps = {
  breakpoint: ScreenSize;
  matchRule: MatchRule;
  children: ReactNode;
};

const UnmountAtBreakpoint = ({ breakpoint, matchRule, children }: UnmountAtBreakpointProps): JSX.Element | null => {
  const matches = useBreakpoint(breakpoint, matchRule);

  if (matches) {
    return null;
  }

  return <>{children}</>;
};

export default UnmountAtBreakpoint;
